import React, { Component } from 'react';
import CountryService from '../../../Services/CountryService';
import PricingService from '../../../Services/PricingService';
import MultiSelectList from '../../../Elements/MultiSelectList';
import PricingCountryRequestItem from '../../../Domain/PricingCountryRequestItem';
import CountryItem from '../../../Domain/CountryItem';
import ErrorMessage from '../../../Elements/ErrorMessage';

export default class PricingCountrySelector extends Component {
  static defaultProps = {
    clickOnCancel: () => {
      alert('Empty function');
    },
    ServiceId: 0,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <MultiSelectList
        title={`Add Pricing ${this.props.ServiceId}`}
        clickOnCancel={this.props.clickOnCancel}
        onSaveFunction={(item) =>
          PricingService.Post(item).then((result) => {
            if (!result?.error) {
              ErrorMessage.SetInfo('Pricings were created with Prism platform pricings.');
            }
            return result;
          })
        }
        requestItem={new PricingCountryRequestItem(this.props.ServiceId)}
        serviceFunction={CountryService.GetCountryList}
        itemType={CountryItem}
        convertDBItemsFunction={CountryService.ConvertDBCountry}
      />
    );
  }
}
